import { render } from "./ButtonDateRange.vue?vue&type=template&id=caf0b4c4"
import script from "./ButtonDateRange.vue?vue&type=script&lang=js"
export * from "./ButtonDateRange.vue?vue&type=script&lang=js"

import "./ButtonDateRange.vue?vue&type=style&index=0&id=caf0b4c4&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__